import React, { useContext, useEffect, useState } from 'react'
import "../AdminDashboard.css"
import "./AddTransaction.css"
import axios from "axios"
import { AuthContext } from '../../../../Context/AuthContext'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment"
import { Card, Button, Badge, Select } from '../../../../ui'
import ReceiptIcon from '@material-ui/icons/Receipt';
import CircularProgress from '@material-ui/core/CircularProgress';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';

function AddTransaction() {
    const API_URL = process.env.REACT_APP_API_URL
    const [isLoading, setIsLoading] = useState(false)
    const { user } = useContext(AuthContext)

    const [borrowerId, setBorrowerId] = useState("")
    const [borrowerDetails, setBorrowerDetails] = useState(null)
    const [bookId, setBookId] = useState("")
    const [recentTransactions, setRecentTransactions] = useState([])
    const [allMembers, setAllMembers] = useState([])
    const [allBooks, setAllBooks] = useState([])

    const [fromDate, setFromDate] = useState(null)
    const [fromDateString, setFromDateString] = useState(null)

    const [toDate, setToDate] = useState(null)
    const [toDateString, setToDateString] = useState(null)

    const transactionTypes = [
        { value: 'Reserved', text: 'Reserve' },
        { value: 'Issued', text: 'Issue' }
    ]

    const [transactionType, setTransactionType] = useState("")

    /* Adding a Transaction */
    const addTransaction = async (e) => {
        e.preventDefault()
        setIsLoading(true)
        if (bookId !== "" && borrowerId !== "" && transactionType !== "" && fromDate !== null && toDate !== null) {
            const borrower_details = await axios.get(API_URL + "api/users/getuser/" + borrowerId)
            const book_details = await axios.get(API_URL + "api/books/getbook/" + bookId)

            /* Checking weather the book is available or not */
            if ((book_details.data.bookCountAvailable > 0 && (transactionType === "Issued" || transactionType === "Reserved")) || (book_details.data.bookCountAvailable === 0 && transactionType === "Reserved")) {
                const transactionData = {
                    bookId: bookId,
                    borrowerId: borrowerId,
                    borrowerName: borrower_details.data.userFullName,
                    bookName: book_details.data.bookName,
                    transactionType: transactionType,
                    fromDate: fromDateString,
                    toDate: toDateString,
                    isAdmin: user.isAdmin
                }
                try {
                    const response = await axios.post(API_URL + "api/transactions/add-transaction", transactionData)
                    if (recentTransactions.length >= 5) {
                        (recentTransactions.splice(-1))
                    }
                    await axios.put(API_URL + `api/users/${response.data._id}/move-to-activetransactions`, {
                        userId: borrowerId,
                        isAdmin: user.isAdmin
                    })

                    await axios.put(API_URL + "api/books/updatebook/" + bookId, {
                        isAdmin: user.isAdmin,
                        bookCountAvailable: book_details.data.bookCountAvailable - 1
                    })

                    setRecentTransactions([response.data, ...recentTransactions])
                    setBorrowerId("")
                    setBookId("")
                    setTransactionType("")
                    setFromDate(null)
                    setToDate(null)
                    setFromDateString(null)
                    setToDateString(null)
                    setBorrowerDetails(null)
                    alert("Transaction was Successfull 🎉")
                }
                catch (err) {
                    console.log(err)
                    alert("Failed to add transaction. Please try again.")
                }
            }
            else {
                alert("The book is not available")
            }
        }
        else {
            alert("Fields must not be empty")
        }
        setIsLoading(false)
    }

    /* Fetch Transactions */
    useEffect(() => {
        const getTransactions = async () => {
            try {
                const response = await axios.get(API_URL + "api/transactions/all-transactions")
                setRecentTransactions(response.data.slice(0, 5))
            }
            catch (err) {
                console.log("Error in fetching transactions")
            }
        }
        getTransactions()
    }, [API_URL])

    /* Fetching borrower details */
    useEffect(() => {
        const getBorrowerDetails = async () => {
            try {
                if (borrowerId !== "") {
                    const response = await axios.get(API_URL + "api/users/getuser/" + borrowerId)
                    setBorrowerDetails(response.data)
                } else {
                    setBorrowerDetails(null)
                }
            }
            catch (err) {
                console.log("Error in getting borrower details")
            }
        }
        getBorrowerDetails()
    }, [API_URL, borrowerId])

    /* Fetching members - load on focus */
    const loadMembers = async () => {
        if (allMembers.length > 0) return; // Already loaded
        try {
            const response = await axios.get(API_URL + "api/users/allmembers")
            if (response.data && response.data.length > 0) {
                const all_members = response.data.map(member => (
                    { value: `${member?._id}`, text: `${member?.userType === "Student" ? `${member?.userFullName}[${member?.admissionId}]` : `${member?.userFullName}[${member?.employeeId}]`}` }
                ))
                setAllMembers(all_members)
            }
        }
        catch (err) {
            console.log("Error loading members:", err)
        }
    }

    /* Fetching books - load on focus */
    const loadBooks = async () => {
        if (allBooks.length > 0) return; // Already loaded
        try {
            const response = await axios.get(API_URL + "api/books/allbooks")
            if (response.data && response.data.length > 0) {
                const allbooks = response.data.map(book => (
                    { value: `${book._id}`, text: `${book.bookName}` }
                ))
                setAllBooks(allbooks)
            }
        } catch (err) {
            console.log("Error loading books:", err)
        }
    }

    const activeTransactions = borrowerDetails?.activeTransactions?.filter((data) => {
        return data.transactionStatus === "Active"
    }) || []

    const calculateFine = (toDate) => {
        const daysOverdue = Math.floor((Date.parse(moment(new Date()).format("MM/DD/YYYY")) - Date.parse(toDate)) / 86400000)
        return daysOverdue <= 0 ? 0 : daysOverdue * 10
    }

    const issuedCount = borrowerDetails?.activeTransactions?.filter((data) => {
        return data.transactionType === "Issued" && data.transactionStatus === "Active"
    }).length || 0

    const reservedCount = borrowerDetails?.activeTransactions?.filter((data) => {
        return data.transactionType === "Reserved" && data.transactionStatus === "Active"
    }).length || 0

    return (
        <div className="addtransaction-container">
            <h2 className="addtransaction-title">Add a Transaction</h2>

            <Card padding="lg" className="addtransaction-form-card">
                <form className='addtransaction-form' onSubmit={addTransaction}>
                    <div className="addtransaction-form-grid">
                        <Select
                            id="borrower-select"
                            label={
                                <>
                                    Borrower<span className="required-field">*</span>
                                </>
                            }
                            placeholder="Select Member"
                            searchable
                            clearable
                            value={borrowerId}
                            options={allMembers}
                            onChange={(e) => setBorrowerId(e.target.value)}
                            onFocus={loadMembers}
                            onOpen={loadMembers}
                        />

                        {borrowerDetails && borrowerId && (
                            <Card padding="md" className="addtransaction-borrower-info">
                                <div className="addtransaction-borrower-header">
                                    <AccountCircleIcon style={{ fontSize: 40 }} />
                                    <div>
                                        <h4>{borrowerDetails.userFullName}</h4>
                                        <div className="addtransaction-borrower-stats">
                                            <Badge variant="primary">Issued: {issuedCount}</Badge>
                                            <Badge variant="secondary">Reserved: {reservedCount}</Badge>
                                            <Badge variant="success">Points: {borrowerDetails.points || 0}</Badge>
                                        </div>
                                    </div>
                                </div>

                                {activeTransactions.length > 0 && (
                                    <div className="addtransaction-borrower-transactions">
                                        <h5>Active Transactions</h5>
                                        <div className="addtransaction-table-wrapper">
                                            <table className="addtransaction-borrower-table">
                                                <thead>
                                                    <tr>
                                                        <th>Book Name</th>
                                                        <th>Type</th>
                                                        <th>From Date</th>
                                                        <th>To Date</th>
                                                        <th>Fine</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {activeTransactions.map((data, index) => (
                                                        <tr key={index}>
                                                            <td>{data.bookName}</td>
                                                            <td>
                                                                <Badge variant={data.transactionType === "Issued" ? "primary" : "secondary"}>
                                                                    {data.transactionType}
                                                                </Badge>
                                                            </td>
                                                            <td>{data.fromDate}</td>
                                                            <td>{data.toDate}</td>
                                                            <td>
                                                                <Badge variant={calculateFine(data.toDate) > 0 ? "danger" : "success"}>
                                                                    ₹{calculateFine(data.toDate)}
                                                                </Badge>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </Card>
                        )}

                        <Select
                            id="book-select"
                            label={
                                <>
                                    Book Name<span className="required-field">*</span>
                                </>
                            }
                            placeholder="Select a Book"
                            searchable
                            clearable
                            value={bookId}
                            options={allBooks}
                            onChange={(e) => setBookId(e.target.value)}
                            onFocus={loadBooks}
                            onOpen={loadBooks}
                        />

                        <Select
                            id="transaction-type-select"
                            label={
                                <>
                                    Transaction Type<span className="required-field">*</span>
                                </>
                            }
                            placeholder="Select Transaction Type"
                            value={transactionType}
                            options={transactionTypes}
                            onChange={(e) => setTransactionType(e.target.value)}
                        />

                        <div className="addtransaction-form-group">
                            <label className="addtransaction-form-label">From Date<span className="required-field">*</span></label>
                            <DatePicker
                                className="addtransaction-datepicker"
                                placeholderText="MM/DD/YYYY"
                                selected={fromDate}
                                onChange={(date) => { setFromDate(date); setFromDateString(moment(date).format("MM/DD/YYYY")) }}
                                minDate={new Date()}
                                dateFormat="MM/dd/yyyy"
                            />
                        </div>

                        <div className="addtransaction-form-group">
                            <label className="addtransaction-form-label">To Date<span className="required-field">*</span></label>
                            <DatePicker
                                className="addtransaction-datepicker"
                                placeholderText="MM/DD/YYYY"
                                selected={toDate}
                                onChange={(date) => { setToDate(date); setToDateString(moment(date).format("MM/DD/YYYY")) }}
                                minDate={fromDate || new Date()}
                                dateFormat="MM/dd/yyyy"
                            />
                        </div>
                    </div>

                    <Button
                        type="submit"
                        variant="primary"
                        size="lg"
                        disabled={isLoading}
                        leadingIcon={isLoading ? <CircularProgress size={20} /> : <ReceiptIcon />}
                        className="addtransaction-submit"
                    >
                        {isLoading ? 'Adding...' : 'Add Transaction'}
                    </Button>
                </form>
            </Card>

            <div className="addtransaction-recent">
                <h3 className="addtransaction-section-title">Recent Transactions</h3>
                {recentTransactions.length > 0 ? (
                    <Card padding="md" className="addtransaction-table-card">
                        <div className="addtransaction-table-wrapper">
                            <table className="addtransaction-table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Book Name</th>
                                        <th>Borrower Name</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {recentTransactions.map((transaction, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{transaction.bookName}</td>
                                            <td>{transaction.borrowerName}</td>
                                            <td>{transaction.updatedAt ? transaction.updatedAt.slice(0, 10) : 'N/A'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Card>
                ) : (
                    <Card padding="lg" className="addtransaction-empty-state">
                        <ReceiptIcon style={{ fontSize: 48, marginBottom: 16 }} />
                        <p>No recent transactions found.</p>
                    </Card>
                )}
            </div>
        </div>
    )
}

export default AddTransaction
